document.addEventListener("DOMContentLoaded", function () {
  // to put cursor into search field and highlight it on certain pages
  function search_shortcut(e) {
    // this would test for whichever key is 40 and the ctrl key at the same time
    if (e.which == 191 || e.keyCode == 191) {
      // do the thing
      if (document.querySelector("input:focus, textarea:focus, select:focus")) {
        // do nothing, because shouldn't trigger shortcut
        return;
      }

      const searchField = document.querySelector(".admin-search-input");
      if (searchField) {
        searchField.focus();
        searchField.select();
      }
    }
  }

  // register handler for / shortcut for search field
  document.addEventListener("keyup", search_shortcut, false);
});
